import { AddressColumn, BsrsGrid, Column } from '@/components/BsrsGrid'
import React from 'react'
import { useLocalization } from '@/hooks/localization'

const BlacklistReportGridBankState = ({ dataSource, sheetHeader }) => {
  const { localize, localizeProps } = useLocalization()

  const bankState = ({ dataItem }) => {
    return dataItem.bankState ? <td>{dataItem.bankState[localizeProps()]}</td> : <td />
  }

  const bankStateExport = ({ dataItem, localizeProps }) => {
    return dataItem.bankState ? dataItem.bankState[localizeProps()] : <td />
  }

  return <BsrsGrid
    name='cbiIgnoredBlacklists' inputType='grid' readonly
    dataSource={dataSource} sheetHeader={sheetHeader}>
    <Column field='name' title={localize('Common.ArabicName')} />
    <Column field='latinName' title={localize('Common.LatinName')} />
    <Column field='code' title={localize('Common.Code')} />
    {AddressColumn({ dataField: 'address', locale: 'ar', field: 'address', title: localize('Common.ArabicAddress'), filterable: false, editable: false })}
    {AddressColumn({ dataField: 'address', locale: 'en', field: 'latinAddress', title: localize('Common.EnglishAddress'), filterable: false, editable: false })}
    {AddressColumn({ dataField: 'previousAddress', locale: 'ar', field: 'previousAddress', title: localize('Common.PreviousArabicAddress'), filterable: false, editable: false })}
    {AddressColumn({ dataField: 'previousAddress', locale: 'en', field: 'previousLatinAddress', title: localize('Common.PreviousEnglishAddress'), filterable: false, editable: false })}
    <Column field='bankState' cell={bankState} cellExport={bankStateExport} title={localize('Common.Status')} filterable={false} editable={false} />
  </BsrsGrid>
}

export { BlacklistReportGridBankState }



// WEBPACK FOOTER //
// ./src/internal-app/pages/blacklistReports/blacklistReportGridBankState.js